import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        width: document.body.clientWidth
    },
    getters: {
        isPc: state => {
            return state.width > 450
        }
    },
    mutations: {
        CHANGE_WIDTH(state, width) {
            state.width = width
        }
    },
    actions: {},
    modules: {}
})
